import { render, staticRenderFns } from "./CJabasProcessEnd.vue?vue&type=template&id=0ff893c8&scoped=true"
import script from "./CJabasProcessEnd.vue?vue&type=script&lang=js"
export * from "./CJabasProcessEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff893c8",
  null
  
)

export default component.exports